import { css } from "styled-components";
import "react-toastify/dist/ReactToastify.css";

export const ToastStyles = css`
  .Toastify {
    ${({ theme }) => css`
          &__toast-body {
            font-size: ${theme.fonts.sizes.p};
            color: ${theme.colors.white};
          }
        }

        .Toastify__close-button {
          color: ${theme.colors.white};
          opacity: 0;
        }

        .Toastify__toast--success {
          background: ${theme.colors.success};
        }

        .Toastify__toast--error {
          background: ${theme.colors.error};
        }

        .Toastify__toast--warning {
          background: ${theme.colors.warn};
        }

        .Toastify__toast--default {
          background: ${theme.colors.primaryDark};
        }

        .Toastify__progress-bar--default {
          background: ${theme.colors.primaryLight};
        }
    `}
  }
`;
